// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"44ce9c78","848":"4d14e066"}[chunkId] + ".chunk.css";
};